/**
 * Tenant onboarding import orchestration.
 * Parses spreadsheets in the UI (see csvDtoMapper), maps to batch DTOs, posts JSON batch APIs.
 */
import { CSV_IMPORT_KEYS, CSV_IMPORT_SEQUENCE } from '../config/csvImportConfig';
import { supplyChainBatchService } from './supplyChainBatchService';

export { CSV_IMPORT_KEYS, CSV_IMPORT_SEQUENCE };

export const csvImportService = {
  CSV_IMPORT_KEYS,
  CSV_IMPORT_SEQUENCE,

  /** @param {string} importKey @param {Record<string, string>[]} mappedRows */
  uploadMappedRows(importKey, mappedRows, userId) {
    return supplyChainBatchService.uploadByImportKey(importKey, mappedRows, userId);
  },

  /** @deprecated Use uploadMappedRows — kept for callers passing mapped row arrays. */
  uploadCsvByKey(importKey, mappedRowsOrFile, userId) {
    if (mappedRowsOrFile instanceof File) {
      return Promise.resolve({
        success: false,
        message: 'File upload is no longer supported. Map columns and confirm to send JSON batch data.',
      });
    }
    return this.uploadMappedRows(importKey, mappedRowsOrFile, userId);
  },
};
